var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['layout', { 'layout--bg-yellow-blue': this.$route.meta.backgroundColor === 'yellow-blue' }]},[_c('main',{staticClass:"container-fluid"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }